document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-removable-item').forEach((element) => {
    let removableElement = element;
    let removeControl = element.querySelector('.js-remove-control');
    if (removeControl) {
      removeControl.addEventListener('click', (event) => { removableElement.remove() })
    }
  })
})
